import { useHref, useLink, useNavigate } from "@made-people/grease-link";
import { useTranslate } from "@made-people/grease-translations";
import { useSearchParams } from "react-router";

export const BlogTags = (props: {
  tags: { name: string; taggings_count: number }[];
}) => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const href = useHref();
  const Link = useLink();
  const translate = useTranslate();
  const selectedCategorySlug = searchParams.get("tag") ?? "";

  return (
    <div className="flex flex-col gap-5 border-b border-neutral-200 pb-6 lg:flex-row lg:items-end lg:justify-between lg:pb-8">
      <div className="flex flex-col gap-2">
        <h1 className="font-secondary text-heading-xl">
          <Link href="blog">{translate("Blog_Header_Title")}</Link>
        </h1>
      </div>
      <div className="relative w-full min-w-0 max-w-full lg:max-w-xs">
        <select
          value={selectedCategorySlug}
          onChange={(e) => {
            const tag = props.tags.find((tag) => tag.name === e.target.value);
            if (tag) {
              navigate(href(`blog?tag=${tag.name}`));
              return;
            }

            navigate(href("blog"));
          }}
          className="block w-full min-w-0 max-w-full appearance-none border border-neutral-300 bg-white px-4 py-3 pr-12 text-body-md focus:border-black focus:outline-none"
        >
          <option value="">{translate("Blog_Tag_Select_All")}</option>
          {props.tags
            .filter(
              (tag) => tag.name.startsWith("blog-") && tag.taggings_count > 0,
            )
            .map((tag) => (
              <option key={tag.name} value={tag.name}>
                {translate(`Blog_Tag_${tag.name}`)} ({tag.taggings_count})
              </option>
            ))}
        </select>
        <svg
          className="pointer-events-none absolute right-4 top-1/2 h-4 w-4 -translate-y-1/2"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
          strokeWidth={1.5}
          aria-hidden="true"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M19.5 8.25L12 15.75 4.5 8.25"
          />
        </svg>
      </div>
    </div>
  );
};
